angular.module('bizmetryApp').controller('DownloadAgentDialogController', function (
  $scope, $mdDialog, $mdToast, agent, TelemetryAgentService, dialogService
) {
  $scope.agent = agent;
  $scope.progress = null;
  $scope.progressMB = "0 MB";

  // 🎯 Controlador de cancelación mutable
  const abortController = {};

  function showDownloadError(error) {
    $scope.failed = true;
    const message = error && error.message ? error.message : String(error || 'Unable to download agent.');
    // The standard dialog renders HTML; API messages are plain text.
    const safeMessage = message.replace(/[&<>"']/g, character => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[character]));
    return dialogService.showErrorDialog('Download Failed', safeMessage, {
      requireAcknowledgement: true
    }).then(function () {
      // The error dialog has finished closing; the download dialog is now on top.
      return $mdDialog.cancel();
    });
  }

  // 🚀 Iniciar descarga del agente con barra de progreso
  TelemetryAgentService.downloadAgentWithProgress(agent.agentId, function (progress) {
    $scope.$evalAsync(function () {
      $scope.progress = progress.pct;
      $scope.progressMB = progress.mbTotal ? `${progress.mbLoaded} / ${progress.mbTotal} MB` : `${progress.mbLoaded} MB`;
    });
  }, abortController).then(function (data) {
    const buffer = new Uint8Array(data);

    // 🧪 Validación ZIP por magic bytes
    const isZip = (
      buffer[0] === 0x50 &&
      buffer[1] === 0x4B &&
      buffer[2] === 0x03 &&
      buffer[3] === 0x04
    );

    if (!isZip) {
      console.error('Invalid ZIP signature:', buffer.slice(0, 8));
      return showDownloadError('The server did not return a valid agent ZIP. No file was downloaded.');
    }

    // 💾 Crear archivo descargable
    const file = new Blob([data], { type: 'application/zip' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(file);

    const now = new Date();
    const pad = n => n.toString().padStart(2, '0');
    const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
    link.download = `agent-${agent.agentName}-${timestamp}.zip`;
    link.click();

    $mdToast.showSimple('Download complete!');
    $mdDialog.hide();
  }).catch(function (error) {
    console.error('Download failed:', error);
    if (error === 'Download aborted by user') {
      $mdToast.showSimple('Download cancelled by user.');
    } else {
      return showDownloadError(error);
    }
    $mdDialog.cancel();
  });

  // 🟥 Acción de cancelar descarga desde botón Cancel
  $scope.cancelDownload = function () {
    if ($scope.failed) return;
    if (abortController.abort) {
      console.warn('Download manually cancelled');
      abortController.abort(); // ⛔️ Aborta el XHR
    }
    // El cierre del diálogo se maneja en el `.catch`
  };
});
